import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import clientPhoto from "../../Assets/Ankush/NYC-logo-header.png";
import "./Header.css";
import icon from "../../Assets/Ankush/imagesnew.jpg";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../msalConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';

const Header = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const opportunityId = searchParams.get('opportunityId');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { instance } = useMsal();

  const generateAndStoreToken = async (email) => {
    try {
      // Call the API to generate a 30-minute token
      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/auth/verify/generate-120min-token`, { email });

      // Check if the response is successful and contains the token
      if (response.data.token) {
        // Store the token in localStorage
        localStorage.setItem('120MinToken', response.data.token);
        console.log('Token stored successfully:', response.data.token);
      } else {
        console.error('No token received:', response.data.message);
      }
    } catch (error) {
      console.error('Error generating token:', error.response ? error.response.data : error.message);
    }
  };

  const handleEmailSubmit = async (e) => {
    setLoading(true)
    try {
      e.preventDefault();
      try {
        const loginResponse = await instance.loginPopup(loginRequest);
        // Acquire token for Dynamics scope (silent first, popup fallback)
        const tokenResponse = await instance.acquireTokenSilent({
          scopes: [process.env.REACT_APP_AUTHENTICATE],
          account: loginResponse.account,
        }).catch(async (err) => {
          return instance.acquireTokenPopup({
            scopes: [process.env.REACT_APP_AUTHENTICATE],
          });
        });

        if (tokenResponse.accessToken) {
          // console.log("tokenResponse", tokenResponse);
          await generateAndStoreToken(tokenResponse.account.username)
          toast.success("Login successful. Please wait while we redirect you to the next screen");
          localStorage.setItem("validWithOTP", true);
          localStorage.setItem("callApiData", true)
          localStorage.setItem("validSalesPerson", true);
          localStorage.setItem("validNewCustomer", true);
          localStorage.setItem('scannedQR', false);
          localStorage.setItem("NewUserEmail", tokenResponse.account.username);
          localStorage.setItem("newUserValidation", false)
          setTimeout(() => {
            // navigate("/home/inventory");
            window.location.reload();
            setLoading(false)
          }, 3000);
        }
        else {
          toast.error("Invalid credentials or user does not exist.");
          setLoading(false)
        }
      } catch (err) {
        console.error("Login error", err);
        toast.error("Error in Login. Please contact Admin.");
      }
      // if (response.ok) {
      //   await generateAndStoreToken(email)
      //   toast.success("Login successful. Please wait while we redirect you to the next screen");
      //   localStorage.setItem("validWithOTP", true);
      //   localStorage.setItem("callApiData", true)
      //   localStorage.setItem("validSalesPerson", true);
      //   localStorage.setItem("validNewCustomer", true);
      //   localStorage.setItem('scannedQR', false);
      //   localStorage.setItem("NewUserEmail", email);
      //   localStorage.setItem("newUserValidation", false)
      //   setTimeout(() => {
      //     navigate("/home/inventory");
      //     window.location.reload();
      //     setLoading(false)
      //   }, 3000);
      // } else {
      //   toast.error("Invalid credentials or user does not exist.");
      //   setLoading(false)
      // }
    } catch (error) {
      toast.info("Please try again.");
      console.error("Fetch error:", error);
      setLoading(false)
    }
  };

  return (
    <header className="header1">
      <div className="header-content1">
        <img src={clientPhoto} alt="NYC Logo" className="client-photo" />
        <h2>Welcome to NYC Digital Catalogue</h2>
        <div className="login-container">
          <div className="w-full flex gap-2">
            <img src={icon} alt="Login Icon" className="login-icon" />
            <label className="login-link">Login</label>
          </div>
          <div className="dropdown1">
            {/* <Link to={`/new-customer${location.search}`}>New Customer</Link> */}
            {/* <Link to={`/existing-customer${location.search}`}>Existing Customer</Link> */}
            <Link to={`/sales-person${location.search}`}>Sales Person</Link>
            {/* <Link to="/generate-qrCode">Show QR</Link>
            <Link to="/scan-qrCode">Scan QR</Link> */}
            {/* <Link onClick={handleEmailSubmit}>Sales Person</Link> */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
